var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',{staticClass:"text-gray mb-2"},[_c('span',[_vm._v(" "+_vm._s(_vm.$t('messages.app.ui.read_question'))+" ")])]),(_vm.question.isText)?_c('div',{staticClass:"text-question-container",domProps:{"innerHTML":_vm._s(_vm.question.questionContent)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }